export default __webpack_public_path__ + "static/media/287.10e507f2.jpg";